import { Component, OnInit } from "@angular/core";
import { MqttService } from "src/app/services/mqtt.service";
import { CommonApiService } from "src/app/services/common-api.service";
import { first } from "rxjs/operators";
import * as moment from "moment";
import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-dashboard-right',
  templateUrl: './dashboard-right.component.html',
  styleUrls: ['./dashboard-right.component.scss']
})
export class DashboardRightComponent implements OnInit {
  topApplianceUsage: any;
  loader: boolean = false;
  startTime: any;
  page: Number = 0;
  count: Number = 3;
  profile: any;
  constructor(public commonApi: CommonApiService, public router: Router, public afAuth: AngularFireAuth) { }

  ngOnInit(): void {
    this.loader = true;
    this.commonApi
      .getApplianceUsageLogs(this.page, this.count)
      .pipe(first())
      .subscribe((res) => {
        this.loader = false;
        this.topApplianceUsage = res;
        console.log(res);

        this.topApplianceUsage.forEach((time) => {
          this.startTime = moment(time["start"]).format("LT");
          console.log(this.startTime);
        });
      });
    this.getCurrentUser();
  }

  analysis_question(id) {
    console.log(id);

    this.router.navigateByUrl(`/analysis`, { state: id });
  }

  getCurrentUser() {
    this.commonApi.getUserData().pipe(first()).subscribe(res => {
      this.profile = res;
      console.log(this.profile);
    })
  }

  logout() {
    this.afAuth.signOut();
    localStorage.clear();
    this.router.navigate(["/login"]);
    localStorage.removeItem("user");
  }

  openNav() {
    // document.getElementById("mySidenav").style.width = "320px";
    document.getElementById("mySidenav").classList.add("mySidenav");
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    document.getElementById("overlay").style.display = "block";
    // document.getElementById("main").style.marginRight = "250px";
  }

  closeNav() {
    document.getElementById("mySidenav").classList.remove("mySidenav");
    document.body.style.backgroundColor = "white";
    document.getElementById("overlay").style.display = "none";
    // document.getElementById("main").style.marginRight= "0";
  }

}
